import Resources from '@/Resources.js';
import { projectExplorationTagKeys } from './HomeUtilityConstants';
import { projectExplorerSearchParamsValues } from './HomeUtilitySearchParams';
import { buildExploreUrlParams } from './HomeUtilityHelpers';

function getResourceLabelForKey(key) {
    const labelMap = {
        [projectExplorationTagKeys.techAndInnovationForYou]: Resources.Homepage.ExploreSegmentForYou,
        [projectExplorationTagKeys.techAndInnovationUpcoming]: Resources.Homepage.UpcomingSectionTitle,
        [projectExplorationTagKeys.techAndInnovationCrowdfunding]: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        [projectExplorationTagKeys.techAndInnovationLatePledge]: Resources.Homepage.LatePledgeProjectsSectionTitle,
        [projectExplorationTagKeys.techAndInnovationEndingSoon]: Resources.Homepage.ExploreSegmentEndingSoon,
        [projectExplorationTagKeys.creativeWorksForYou]: Resources.Homepage.ExploreSegmentForYou,
        [projectExplorationTagKeys.creativeWorksUpcoming]: Resources.Homepage.UpcomingSectionTitle,
        [projectExplorationTagKeys.creativeWorksCrowdfunding]: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        [projectExplorationTagKeys.creativeWorksLatePledge]: Resources.Homepage.LatePledgeProjectsSectionTitle,
        [projectExplorationTagKeys.creativeWorksEndingSoon]: Resources.Homepage.ExploreSegmentEndingSoon,
        [projectExplorationTagKeys.communityProjectsForYou]: Resources.Homepage.ExploreSegmentForYou,
        [projectExplorationTagKeys.communityProjectsUpcoming]: Resources.Homepage.UpcomingSectionTitle,
        [projectExplorationTagKeys.communityProjectsCrowdfunding]: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        [projectExplorationTagKeys.communityProjectsLatePledge]: Resources.Homepage.LatePledgeProjectsSectionTitle,
        [projectExplorationTagKeys.communityProjectsEndingSoon]: Resources.Homepage.ExploreSegmentEndingSoon,
        [projectExplorationTagKeys.mostDiscussedAll]: Resources.Homepage.ProjectListAllSegmentTitle,
        [projectExplorationTagKeys.mostDiscussedUpcoming]: Resources.Homepage.UpcomingSectionTitle,
        [projectExplorationTagKeys.mostDiscussedCrowdfunding]: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        [projectExplorationTagKeys.mostDiscussedLatePledge]: Resources.Homepage.LatePledgeProjectsSectionTitle,
        [projectExplorationTagKeys.recentlyAddedUpdatesAll]: Resources.Homepage.ProjectListAllSegmentTitle,
        [projectExplorationTagKeys.recentlyAddedUpdatesUpcoming]: Resources.Homepage.UpcomingSectionTitle,
        [projectExplorationTagKeys.recentlyAddedUpdatesCrowdfunding]: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        [projectExplorationTagKeys.recentlyAddedUpdatesLatePledge]: Resources.Homepage.LatePledgeProjectsSectionTitle,
    };
    return labelMap[key];
}

function buildTagFromKey(key) {
    return {
        label: getResourceLabelForKey(key),
        key,
        searchParams: projectExplorerSearchParamsValues[key],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[key]),
    };
}

function buildCategoryTags(keys) {
    return [
        buildTagFromKey(keys.forYou),
        buildTagFromKey(keys.upcoming),
        buildTagFromKey(keys.crowdfunding),
        buildTagFromKey(keys.latePledge),
        buildTagFromKey(keys.endingSoon),
    ];
}

function buildPhaseTags(keys) {
    return [
        buildTagFromKey(keys.all),
        buildTagFromKey(keys.upcoming),
        buildTagFromKey(keys.crowdfunding),
        buildTagFromKey(keys.latePledge),
    ];
}

export const buildExploreProjectTags = (isAuthenticated = false) => [
    {
        label: isAuthenticated
            ? Resources.Homepage.ExploreSegmentForYou
            : Resources.Homepage.ExploreSegmentYouMayLike,
        key: projectExplorationTagKeys.exploreYouMayLike,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreYouMayLike],
        actionLabel: Resources.Homepage.ExploreSegmentActionLabelGeneral,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreYouMayLike]),
    },
    {
        label: Resources.Homepage.ExploreSegmentActive,
        key: projectExplorationTagKeys.exploreActive,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreActive],
        actionLabel: Resources.Homepage.ExploreSegmentActionLabelActive,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreActive]),
    },
    {
        label: Resources.Homepage.ExploreSegmentEndingSoon,
        key: projectExplorationTagKeys.exploreEndingSoon,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreEndingSoon],
        actionLabel: Resources.Homepage.ExploreSegmentActionLabelEndingSoon,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.exploreEndingSoon]),
    },
];

export const buildCrowdfundingProjectTags = (filterFunction = () => true) => [
    {
        label: Resources.Homepage.ProjectListTrendingSegmentTitle,
        key: projectExplorationTagKeys.crowdfundingTrending,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingTrending],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingTrending]),
    },
    {
        label: Resources.Homepage.ProjectListNewSegmentTitle,
        key: projectExplorationTagKeys.crowdfundingNew,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingNew],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingNew]),
    },
    {
        label: Resources.Homepage.ProjectListMostFundedSegmentTitle,
        key: projectExplorationTagKeys.crowdfundingMostFunded,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingMostFunded],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.crowdfundingMostFunded]),
    },
].filter(filterFunction);

export const buildUpcomingProjectTags = (filterFunction = () => true) => [
    {
        label: Resources.Homepage.ProjectListComingSoonSegmentTitle,
        key: projectExplorationTagKeys.upcomingComingSoon,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingComingSoon],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingComingSoon]),
    },
    {
        label: Resources.Homepage.ProjectListNewSegmentTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingNew],
        key: projectExplorationTagKeys.upcomingNew,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingNew]),
    },
    {
        label: Resources.Homepage.ProjectListMostPopularSegmentTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingMostPopular],
        key: projectExplorationTagKeys.upcomingMostPopular,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.upcomingMostPopular]),
    },
].filter(filterFunction);

export const buildLatePledgeProjectTags = () => [
    {
        label: Resources.Homepage.ProjectListNewSegmentTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.latePledgeNew],
        key: projectExplorationTagKeys.latePledgeNew,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.latePledgeNew]),
    },
    {
        label: Resources.Homepage.ProjectListMostFundedSegmentTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.latePledgeMostFunded],
        key: projectExplorationTagKeys.latePledgeMostFunded,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.latePledgeMostFunded]),
    },
];

export const buildMostDiscussedProjectTags = () => buildPhaseTags({
    all: projectExplorationTagKeys.mostDiscussedAll,
    upcoming: projectExplorationTagKeys.mostDiscussedUpcoming,
    crowdfunding: projectExplorationTagKeys.mostDiscussedCrowdfunding,
    latePledge: projectExplorationTagKeys.mostDiscussedLatePledge,
});

export const buildRecentlyAddedUpdatesProjectTags = () => buildPhaseTags({
    all: projectExplorationTagKeys.recentlyAddedUpdatesAll,
    upcoming: projectExplorationTagKeys.recentlyAddedUpdatesUpcoming,
    crowdfunding: projectExplorationTagKeys.recentlyAddedUpdatesCrowdfunding,
    latePledge: projectExplorationTagKeys.recentlyAddedUpdatesLatePledge,
});

export const buildHighestFundedProjectTags = () => [
    {
        label: Resources.Homepage.ExploreSegmentActive,
        key: projectExplorationTagKeys.highestFundedActive,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.highestFundedActive],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.highestFundedActive]),
    },
    {
        label: Resources.Homepage.ProjectListAllTimeSegmentTitle,
        key: projectExplorationTagKeys.highestFundedAllTime,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.highestFundedAllTime],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.highestFundedAllTime]),
    },
];

export const buildPreordersProjectTags = () => [
    {
        label: Resources.Homepage.PreordersSectionTitle,
        key: projectExplorationTagKeys.preorders,
        searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.preorders],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.preorders]),
    },
];

export const buildTechAndInnovationTags = () => buildCategoryTags({
    forYou: projectExplorationTagKeys.techAndInnovationForYou,
    upcoming: projectExplorationTagKeys.techAndInnovationUpcoming,
    crowdfunding: projectExplorationTagKeys.techAndInnovationCrowdfunding,
    latePledge: projectExplorationTagKeys.techAndInnovationLatePledge,
    endingSoon: projectExplorationTagKeys.techAndInnovationEndingSoon,
});

export const buildCreativeWorksTags = () => buildCategoryTags({
    forYou: projectExplorationTagKeys.creativeWorksForYou,
    upcoming: projectExplorationTagKeys.creativeWorksUpcoming,
    crowdfunding: projectExplorationTagKeys.creativeWorksCrowdfunding,
    latePledge: projectExplorationTagKeys.creativeWorksLatePledge,
    endingSoon: projectExplorationTagKeys.creativeWorksEndingSoon,
});

export const buildCommunityProjectsTags = () => buildCategoryTags({
    forYou: projectExplorationTagKeys.communityProjectsForYou,
    upcoming: projectExplorationTagKeys.communityProjectsUpcoming,
    crowdfunding: projectExplorationTagKeys.communityProjectsCrowdfunding,
    latePledge: projectExplorationTagKeys.communityProjectsLatePledge,
    endingSoon: projectExplorationTagKeys.communityProjectsEndingSoon,
});

export const buildGamingCultureTags = () => {
    return [
        {
            label: Resources.ProjectCatalogCategories.BoardAndCardGames,
            key: projectExplorationTagKeys.gamingCultureBoardAndCard,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureBoardAndCard],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureBoardAndCard]),
        },
        {
            label: Resources.ProjectCatalogCategories.TTRPG,
            key: projectExplorationTagKeys.gamingCultureTTRPG,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureTTRPG],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureTTRPG]),
        },
        {
            label: Resources.ProjectCatalogCategories.VideoGames,
            key: projectExplorationTagKeys.gamingCultureVideo,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureVideo],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureVideo]),
        },
        {
            label: Resources.ProjectCatalogCategories.Others,
            key: projectExplorationTagKeys.gamingCultureOther,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureOther],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.gamingCultureOther]),
        },
    ];
};

export const buildNewOnThePlatformTags = () => {
    return [
        {
            label: Resources.Homepage.UpcomingSectionTitle,
            key: projectExplorationTagKeys.newOnThePlatformUpcoming,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformUpcoming],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformUpcoming]),
        },
        {
            label: Resources.Homepage.CrowdfundingProjectsSectionTitle,
            key: projectExplorationTagKeys.newOnThePlatformCrowdfunding,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformCrowdfunding],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformCrowdfunding]),
        },
        {
            label: Resources.Homepage.LatePledgeProjectsSectionTitle,
            key: projectExplorationTagKeys.newOnThePlatformLatePledge,
            searchParams: projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformLatePledge],
            url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationTagKeys.newOnThePlatformLatePledge]),
        },
    ];
};
